var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2943_41946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7588 0V2.75283H15.595V4.12921C16.5877 3.99159 17.4386 3.99159 18.4313 4.12921V2.75283H21.2675V0H12.7588Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6563 9.08428L27.6489 8.12082L28.7835 9.22197L30.7688 7.29498L26.5145 3.16577L24.5291 5.09276L25.6636 6.19384L24.3873 7.4326C17.5804 3.44101 8.78807 5.50561 4.81738 12.1124C0.846684 18.7191 2.97379 26.9775 9.63894 30.9691C16.3041 34.9607 25.0963 32.8961 29.0671 26.2893C32.6124 20.6461 31.6197 13.4888 26.6563 9.08428ZM17.0131 28.7669C11.4825 28.7669 7.08633 24.5 7.08633 19.1321C7.08633 13.7641 11.4825 9.49721 17.0131 9.49721V19.132H26.9399C26.9399 24.5 22.5437 28.7669 17.0131 28.7669Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2943_41946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.7d0a5dccc8a29d9ab8ce6600d8e70d61.svg";
export { ForwardRef as ReactComponent };